import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function CMSPrayerRequests() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/cms/prayer-requests").then((r) => setItems(r.data || [])).catch(() => setItems([])).finally(() => setLoading(false));
  };
  useEffect(load, []);

  const toggle = async (id) => {
    try {
      await api.patch(`/cms/prayer-requests/${id}`);
      load();
    } catch {
      toast.error("Could not update");
    }
  };

  return (
    <div>
      <h1 className="heading-2">Prayer Requests</h1>
      <p className="text-sm text-ink-muted mt-2">Private — never displayed on the public site.</p>
      {loading ? (
        <p className="mt-6 text-ink-muted">Loading…</p>
      ) : (
        <div className="mt-6 space-y-4">
          {items.map((r) => (
            <div key={r.id} className="paper-card p-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-ink font-medium">{r.name || "Anonymous"}</p>
                  <p className="text-xs text-ink-muted">{r.email || "no email"} · {new Date(r.created_at).toLocaleString()}{r.urgent && <span className="ml-2 text-terracotta-dark font-medium">URGENT</span>}</p>
                </div>
                <button onClick={() => toggle(r.id)} className={`text-xs uppercase tracking-widest px-3 py-1.5 border ${r.handled ? "bg-forest text-background border-forest" : "border-border text-ink-muted"}`}>
                  {r.handled ? "Prayed for" : "Mark prayed"}
                </button>
              </div>
              <p className="mt-4 body-copy text-ink">{r.request}</p>
            </div>
          ))}
          {items.length === 0 && <p className="text-ink-muted">No prayer requests yet.</p>}
        </div>
      )}
    </div>
  );
}
